// Use same backend URL and headers as employees.js
const BASE_URL = import.meta.env.VITE_API_BASE_URL;

function getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Token ${token}` } : {})
    };
}

export async function getEmployeeVacations(employeeId) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    const res = await fetch(`${BASE_URL}/owner/employees/${employeeId}/vacations/`, {
        headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Failed to fetch employee vacations');
    return await res.json();
}

export async function createEmployeeVacation(employeeId, data) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    // Backend expects start_date and end_date
    const payload = {
        start_date: data.start,
        end_date: data.end
    };
    const res = await fetch(`${BASE_URL}/owner/employees/${employeeId}/vacations/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error('Failed to create employee vacation');
    return await res.json();
}

export async function getEmployeeVacation(employeeId, vacationId) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    const res = await fetch(`${BASE_URL}/owner/employees/${employeeId}/vacations/${vacationId}/`, {
        headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Failed to fetch employee vacation');
    return await res.json();
}

export async function updateEmployeeVacation(employeeId, vacationId, data) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    // Backend expects start_date and end_date
    const payload = {
        start_date: data.start,
        end_date: data.end
    };
    const res = await fetch(`${BASE_URL}/owner/employees/${employeeId}/vacations/${vacationId}/`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error('Failed to update employee vacation');
    return await res.json();
}

export async function patchEmployeeVacation(employeeId, vacationId, data) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    const res = await fetch(`${BASE_URL}/owner/employees/${employeeId}/vacations/${vacationId}/`, {
        method: 'PATCH',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to patch employee vacation');
    return await res.json();
}